module.exports = __webpack_public_path__ + "img/13.4fe1dd17.jpeg";